import React from 'react';
import RmsPostFormPage from '../RmsPostFormPage';

export default function ReasonForReferral() {
  return (
    <RmsPostFormPage
      formKey="reasonForReferral"
      afterSubmitRoute={(patientRecordId) => `/rms/patient/${encodeURIComponent(patientRecordId)}/overview`}
      backToRoute={(patientRecordId) => `/rms/patient/${encodeURIComponent(patientRecordId)}/overview`}
    />
  );
}


